import { useSearchParams } from 'react-router-dom';

export type NonOptionalArrayProps<T extends object> = {
  [
    K in keyof T as NonNullable<T[K]> extends unknown[] ? K : never
  ]-?: NonNullable<T[K]>;
} & {
  [K in keyof T as NonNullable<T[K]> extends unknown[] ? never : K]: T[K];
};

export const useDestructureQueryParams = () => {
  const [searchParams] = useSearchParams();

  const query: Record<string, string | string[]> = {};

  for (const key of searchParams.keys()) {
    const allValues = searchParams.getAll(key);
    query[key] = allValues.length > 1 ? allValues : allValues[0];
  }

  return query;
};

//This is for the Report Preview table row display
export const getDeepProperty = (object: object, path: string): unknown =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  path.split('.').reduce((acc: any, key) => acc?.[key], object);

export const isDev = () => {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  if (baseUrl.includes('api.bridge.brigadehealth.com')) return false;
  return true;
};
